import React, { useState, useEffect } from 'react';
import { UserManager } from 'oidc-client';

export const AuthContext = React.createContext(null);

export const hasCodeInUrl = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(location.hash.replace('#', '?'));

  return Boolean(
    searchParams.get('code') ||
      searchParams.get('id_token') ||
      searchParams.get('session_state') ||
      hashParams.get('code') ||
      hashParams.get('id_token') ||
      hashParams.get('session_state')
  );
};

export const initUserManager = (props) => {
  if (props.userManager) return props.userManager;
  const {
    authority,
    clientId,
    clientSecret,
    redirectUri,
    responseType,
    scope,
    automaticSilentRenew,
  } = props;
  return new UserManager({
    authority,
    client_id: clientId,
    client_secret: clientSecret,
    redirect_uri: redirectUri,
    silent_redirect_uri: redirectUri,
    post_logout_redirect_uri: redirectUri,
    response_type: responseType || 'code',
    scope: scope || 'openid',
    loadUserInfo: true,
    automaticSilentRenew
  });
};

export const AuthProvider = ({
  children,
  autoSignIn = true,
  onBeforeSignIn,
  onSignIn,
  onSignOut,
  location = window.location,
  ...props
}) => {
  const [userData, setUserData] = useState(null);

  const userManager = initUserManager(props);

  const signOutHooks = async () => {
    setUserData(null);
    onSignOut && onSignOut();
  };

  useEffect(() => {
    const getUser = async () => {
      if (hasCodeInUrl(location)) {
        const user = await userManager.signinCallback();
        setUserData(user);
        onSignIn && onSignIn(user);
        return;
      }

      const user = await userManager.getUser();
      if ((!user || user.expired) && autoSignIn) {
        onBeforeSignIn && onBeforeSignIn();
        userManager.signinRedirect({ login_hint: props.loginHint });
      } else {
        setUserData(user);
      }
      return;
    };
    getUser();
  }, [location]);

  useEffect(() => {
    const updateUserData = async () => {
      const user = await userManager.getUser();
      setUserData(user);
    };

    userManager.events.addUserLoaded(updateUserData);

    return () => userManager.events.removeUserLoaded(updateUserData);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        signIn: async (args) => {
          await userManager.signinRedirect(args);
        },
        signOut: async () => {
          await userManager.removeUser();
          await signOutHooks();
        },
        signOutRedirect: async (args) => {
          await userManager.signoutRedirect(args);
          await signOutHooks();
        },
        userManager,
        userData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/components/AuthProvider/AuthContext.js